/**
 * @generated SignedSource<<b6c147e5f8da5d3f03463481269f623d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type HubMessageType = "CONVERSATION" | "INFORM";
export type HubComponentQuery$variables = Record<PropertyKey, never>;
export type HubComponentQuery$data = {
  readonly availableCheckins: ReadonlyArray<{
    readonly daysLeft: number | null | undefined;
    readonly displayTitle: string;
    readonly id: string;
    readonly linkUrl: string;
  }>;
  readonly checkinSummary: {
    readonly buttonText: string | null | undefined;
    readonly summaryText: string;
  };
  readonly hubMessages: ReadonlyArray<{
    readonly description: string;
    readonly isRead: boolean;
    readonly timeCreated: string;
    readonly title: string;
    readonly type: HubMessageType;
    readonly url: string;
  }>;
  readonly me: {
    readonly companyName: string;
    readonly firstName: string;
    readonly id: string;
  };
  readonly nextSurvey: {
    readonly daysLeft: number | null | undefined;
    readonly displayTitle: string;
    readonly id: string;
    readonly linkUrl: string;
  } | null | undefined;
};
export type HubComponentQuery = {
  response: HubComponentQuery$data;
  variables: HubComponentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "displayTitle",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "linkUrl",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "daysLeft",
    "storageKey": null
  }
],
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Me",
    "kind": "LinkedField",
    "name": "me",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "firstName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "companyName",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Checkin",
    "kind": "LinkedField",
    "name": "availableCheckins",
    "plural": true,
    "selections": (v1/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Checkin",
    "kind": "LinkedField",
    "name": "nextSurvey",
    "plural": false,
    "selections": (v1/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "CheckinSummary",
    "kind": "LinkedField",
    "name": "checkinSummary",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "summaryText",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "buttonText",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "HubMessage",
    "kind": "LinkedField",
    "name": "hubMessages",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isRead",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "timeCreated",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "HubComponentQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "HubComponentQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "b096ac325fcfb9d8ad0bbabef568c1cf",
    "id": null,
    "metadata": {},
    "name": "HubComponentQuery",
    "operationKind": "query",
    "text": "query HubComponentQuery {\n  me {\n    id\n    firstName\n    companyName\n  }\n  availableCheckins {\n    id\n    displayTitle\n    linkUrl\n    daysLeft\n  }\n  nextSurvey {\n    id\n    displayTitle\n    linkUrl\n    daysLeft\n  }\n  checkinSummary {\n    summaryText\n    buttonText\n  }\n  hubMessages {\n    type\n    isRead\n    timeCreated\n    url\n    title\n    description\n  }\n}\n"
  }
};
})();

(node as any).hash = "d055377b7898a170f16cad0337f62876";

export default node;
